

export class PickupDeliveryItemActionEnum {
    
	static Assembly: number = 0; 
	static Move: number = 1; 
	static Remove: number = 2; 
	static Overweight: number = 3; 
	static FeltPad: number = 4; 
	static Exchange: number = 5; 


	static getChoices(): any[] {
		return [
		{
			Value: PickupDeliveryItemActionEnum.Assembly, Text: 'Assembly'
	},{
			Value: PickupDeliveryItemActionEnum.Move, Text: 'Move'
	},{
			Value: PickupDeliveryItemActionEnum.Remove, Text: 'Remove'
	},{
			Value: PickupDeliveryItemActionEnum.Overweight, Text: 'Overweight'
	},{
			Value: PickupDeliveryItemActionEnum.FeltPad, Text: 'Felt Pad'
	},{
			Value: PickupDeliveryItemActionEnum.Exchange, Text: 'Exchange'
	}
			
		];
	}

}
